import { TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TERMS } from "../../config/terminology";
import { setState, setTotalValues } from "./defineSlice";
import "./Define.css";
import { formatNumber, removeComma } from "./defineUtils";

export default function TableCellWeek2(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, selectedDepletion } = define;
   const [week2, setWeek2] = useState(params.row.weekly2);
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   useEffect(()=>{
      setWeek2(params.row.weekly2);
   },[params.row.weekly2]);

   function updateGrid(hasError, w, quota) {
      if (selectedDepletion.key === "biweekly") {
         if (w !== quota) {
            quota = w;
         }
         dispatch(setState("isFailed", true));
         dispatch(
            setState(
               "isFailed_Info",
               `${TERMS.QUOTA} value has been updated as second half value was edited.`
            )
         );
      }
      let updatedItem = null;
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               quota,
               weekly2: !w ? 0 : w,
            };
            return updatedItem
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
   }

   function updateWeek2(event) {
      let w2 = removeComma(event.target.value);
      w2 = Number(w2);
      let w1 = Number(params.row.weekly1);
      let w3 = Number(params.row.weekly3);
      let quota = Number(params.row.quota);
      let hasError = false;
      setWeek2(w2);

      if (!w2 && w2 !== 0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }

      if (selectedDepletion.key === "biweekly") {
         if (w1 > w2) {
            hasError = true;
         }
      } else {
         if (w1 > w2) {
            hasError = true;
         } else if (w2 > w3) {
            hasError = true;
         }
      }
      dispatch(setState("gridDataChanged", true));
      updateGrid(hasError, w2, quota);
      dispatch(setTotalValues());
   }

   function handleValidity(w1, w2, w3){
      if (selectedDepletion.key === "biweekly") {
         if (w1 > w2) {
            dispatch(setState("isError", true));
            dispatch(
               setState(
                  "isError_Info",
                  "Must be greater or equal to first half"
               )
            );
         }
      } else {
         if (w1 > w2) {
            dispatch(setState("isError", true));
            dispatch(
               setState("isError_Info", "Must be greater or equal to Week1")
            );
         } else if (w2 > w3) {
            dispatch(setState("isError", true));
            dispatch(
               setState("isError_Info", "Must be less or equal to Week3")
            );
         }
      }
   }

   return (
      <TextField
         disabled={selectedDepletion.key === "biweekly"}
         variant="standard"
         value={week2?.toLocaleString('en-US')}
         className={
            params.row.weekly2 > params.row.weekly3
               ? selectedDepletion.key === "biweekly"
                  ? ""
                  : "red-row"
               : ""
         }
         onChange={updateWeek2}
         onBlur={() => {
            handleValidity(params.row.weekly1, params.row.weekly2, params.row.weekly3);
         }}
         sx={{ width: 100 }}
         inputProps={{ style: {textAlign: 'center' } }}
      />
   );
}
